import React, { useEffect, useState } from 'react';
import { splitwiseAPI } from '../../services/api';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';

export const SplitwiseConnectButton: React.FC = () => {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disconnecting, setDisconnecting] = useState(false);

  useEffect(() => {
    splitwiseAPI
      .getStatus()
      .then((data) => setConnected(data.connected))
      .catch(() => setConnected(false))
      .finally(() => setLoading(false));
  }, []);

  const handleConnect = async () => {
    try {
      const { url } = await splitwiseAPI.getAuthUrl();
      window.location.href = url;
    } catch (error) {
      console.error('Failed to get auth URL:', error);
      alert('Failed to initiate Splitwise connection');
    }
  };

  const handleDisconnect = async () => {
    setDisconnecting(true);
    try {
      await splitwiseAPI.disconnect();
      setConnected(false);
    } catch (error) {
      console.error('Failed to disconnect:', error);
    } finally {
      setDisconnecting(false);
    }
  };

  if (loading) {
    return (
      <Card>
        <div className="flex items-center gap-3 animate-pulse">
          <div className="w-10 h-10 bg-slate-200 rounded-xl" />
          <div className="flex-1">
            <div className="h-4 bg-slate-200 rounded w-24 mb-1" />
            <div className="h-3 bg-slate-200 rounded w-36" />
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 ${connected ? 'bg-green-100' : 'bg-teal-100'} rounded-xl flex items-center justify-center`}>
          <svg className={`w-5 h-5 ${connected ? 'text-green-600' : 'text-teal-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-slate-900">Splitwise</p>
          <p className="text-sm text-slate-500">
            {connected ? 'Connected' : 'Sync splits to Splitwise'}
          </p>
        </div>
        {connected ? (
          <Button
            variant="secondary"
            size="sm"
            onClick={handleDisconnect}
            loading={disconnecting}
            className="text-red-600"
          >
            Disconnect
          </Button>
        ) : (
          <Button size="sm" onClick={handleConnect}>
            Connect
          </Button>
        )}
      </div>
    </Card>
  );
};

export default SplitwiseConnectButton;
